module.exports = __webpack_public_path__ + "img/Speedy Laundry.b421cc36.svg";